import React from 'react';
import { TopBar } from '../../components/layout/TopBar';
import { Header } from '../../components/layout/Header';
import { Navigation } from '../../components/layout/Navigation';
import { MobileStickyBar } from '../../components/layout/MobileStickyBar';
import { Footer } from '../../components/layout/Footer';
import { useScreenInit } from '../../useScreenInit';
import { MapPin, Phone, ArrowRight, Sparkles } from 'lucide-react';
export function OurGallery() {
  useScreenInit();
  return <div className="min-h-screen flex flex-col bg-brand-background" data-id="element-1494">
      <TopBar data-id="element-1495" />
      <Header data-id="element-1496" />
      <Navigation data-id="element-1497" />

      <main className="flex-grow" data-id="element-1498">
        {/* Hero */}
        <section className="bg-white border-b border-brand-border py-16 lg:py-24" data-id="element-1499">
          <div className="max-w-7xl mx-auto px-4 text-center" data-id="element-1500">
            <span className="inline-block py-1 px-3 rounded-full bg-brand-goldSoft text-brand-charcoal text-xs font-bold tracking-wide mb-4 uppercase border border-brand-gold/30" data-id="element-1501">
              First Impressions Start at the Curb
            </span>
            <h1 className="text-4xl lg:text-5xl xl:text-6xl font-serif font-bold text-brand-charcoal mb-6 leading-tight" data-id="element-1502">
              Our Gallery
            </h1>
            <p className="text-lg lg:text-xl text-brand-muted max-w-3xl mx-auto leading-relaxed" data-id="element-1503">
              MidAtlantic Mailbox, Inc. is your one-stop-shop for residential &
              commercial mailboxes, outdoor home accessories, street signs, and
              more. Please enjoy our gallery of completed installations for
              reference and inspiration.
            </p>
            <div className="mt-8 flex items-center justify-center gap-6" data-id="element-1504">
              <img src="https://drwzpk38qkpfb.cloudfront.net/www.midatlanticmailboxes.com/uploaded/images/Redesign/woman%20owned%20badge.png" alt="Woman Owned Business" className="h-14 object-contain" data-id="element-1505" />
              <img src="https://drwzpk38qkpfb.cloudfront.net/www.midatlanticmailboxes.com/uploaded/images/Redesign/family%20owned%20badge.png" alt="Family Owned Business" className="h-14 object-contain" data-id="element-1506" />
              <img src="https://drwzpk38qkpfb.cloudfront.net/www.midatlanticmailboxes.com/uploaded/images/Redesign/florence%20logo%20badge.png" alt="Florence Authorized Dealer" className="h-12 object-contain" data-id="element-1507" />
            </div>
          </div>
        </section>

        {/* What We Do */}
        <section className="py-16 bg-brand-background border-b border-brand-border" data-id="element-1508">
          <div className="max-w-5xl mx-auto px-4 text-center" data-id="element-1509">
            <p className="text-brand-muted leading-relaxed text-lg" data-id="element-1510">
              Offering services like commercial mail route mapping, mailbox
              installations, and model identification & diagnostic solutions,
              MidAtlantic Mailbox, Inc. is your mailbox expert. Our experienced
              staff will assist you with the development of distinctive yet
              affordable street themes or development route mapping. We stay
              informed of postal requirements along with emerging industry
              trends to bring you the most up-to-date products and services. If
              you have a mailbox question, we're your answer.
            </p>
            <div className="mt-8 inline-flex items-center gap-2 bg-white border border-brand-border rounded-full px-5 py-2.5 text-sm font-semibold text-brand-charcoal shadow-sm" data-id="element-1511">
              <MapPin size={16} className="text-brand-maroon" data-id="element-1512" />
              Installation in the DC Metropolitan Region & parts of PA, VA, WV,
              MD, and DE
            </div>
          </div>
        </section>

        {/* Premiere Combinations / Browse */}
        <section className="py-16 lg:py-24 bg-white border-b border-brand-border" data-id="element-1513">
          <div className="max-w-7xl mx-auto px-4" data-id="element-1514">
            <div className="text-center max-w-2xl mx-auto mb-12" data-id="element-1515">
              <span className="inline-flex items-center gap-2 text-brand-maroon font-bold tracking-wider uppercase text-xs mb-3" data-id="element-1516">
                <Sparkles size={14} data-id="element-1517" /> Exclusive to MidAtlantic Mailbox
              </span>
              <h2 className="text-3xl font-serif font-bold text-brand-charcoal mb-4" data-id="element-1518">
                Premiere Mailbox System Combinations
              </h2>
              <p className="text-brand-muted" data-id="element-1519">
                Browse our Premiere Mailbox System Combinations, only available
                at MidAtlantic Mailbox, Inc.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1520">
              <a href="/6m8/commercial-mailboxes-lockers.html" className="group bg-brand-background rounded-2xl border border-brand-border overflow-hidden hover:border-brand-maroon transition-colors shadow-sm" data-id="element-1521">
                <div className="aspect-[4/3] bg-brand-goldWash flex items-center justify-center" data-id="element-1522">
                  <span className="text-brand-charcoal/40 text-sm font-medium" data-id="element-1523">
                    Commercial Mailboxes
                  </span>
                </div>
                <div className="p-5" data-id="element-1524">
                  <h3 className="font-bold text-brand-charcoal group-hover:text-brand-maroon transition-colors mb-1" data-id="element-1525">
                    Commercial Mailboxes & Lockers
                  </h3>
                  <p className="text-sm text-brand-muted flex items-center gap-1" data-id="element-1526">
                    Explore the collection{' '}
                    <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" data-id="element-1527" />
                  </p>
                </div>
              </a>

              <a href="/m8/4C16D-20-D--versatile-4c-depot-16h-20-door-package.html" className="group bg-brand-background rounded-2xl border border-brand-border overflow-hidden hover:border-brand-maroon transition-colors shadow-sm" data-id="element-1528">
                <div className="aspect-[4/3] bg-brand-goldWash flex items-center justify-center" data-id="element-1529">
                  <span className="text-brand-charcoal/40 text-sm font-medium" data-id="element-1530">
                    4C Depot Package
                  </span>
                </div>
                <div className="p-5" data-id="element-1531">
                  <h3 className="font-bold text-brand-charcoal group-hover:text-brand-maroon transition-colors mb-1" data-id="element-1532">
                    Featured 4C Mailbox System
                  </h3>
                  <p className="text-sm text-brand-muted flex items-center gap-1" data-id="element-1533">
                    View product details{' '}
                    <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" data-id="element-1534" />
                  </p>
                </div>
              </a>

              <a href="/" className="group bg-brand-background rounded-2xl border border-brand-border overflow-hidden hover:border-brand-maroon transition-colors shadow-sm" data-id="element-1535">
                <div className="aspect-[4/3] bg-brand-goldWash flex items-center justify-center" data-id="element-1536">
                  <span className="text-brand-charcoal/40 text-sm font-medium" data-id="element-1537">
                    Residential & Street Signs
                  </span>
                </div>
                <div className="p-5" data-id="element-1538">
                  <h3 className="font-bold text-brand-charcoal group-hover:text-brand-maroon transition-colors mb-1" data-id="element-1539">
                    Start Browsing
                  </h3>
                  <p className="text-sm text-brand-muted flex items-center gap-1" data-id="element-1540">
                    Back to homepage{' '}
                    <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" data-id="element-1541" />
                  </p>
                </div>
              </a>
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="py-12 bg-brand-charcoal text-center" data-id="element-1542">
          <div className="max-w-3xl mx-auto px-4" data-id="element-1543">
            <p className="text-brand-gold font-bold mb-2" data-id="element-1544">
              MidAtlantic Mailbox, Inc.
            </p>
            <p className="flex items-center justify-center gap-2 text-gray-300 text-sm mb-4" data-id="element-1545">
              <MapPin size={16} className="shrink-0" data-id="element-1546" />
              4507 Metropolitan Court Ste. D, Frederick, MD 21704
            </p>
            <p className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-white text-sm" data-id="element-1547">
              <span className="flex items-center gap-1" data-id="element-1548">
                <Phone size={14} data-id="element-1549" /> Toll Free: 1-800-806-7997
              </span>
              <span className="hidden sm:inline text-gray-500" data-id="element-1550">|</span>
              <span data-id="element-1551">301-620-7585</span>
              <span className="hidden sm:inline text-gray-500" data-id="element-1552">|</span>
              <span data-id="element-1553">301-620-7867</span>
              <span className="hidden sm:inline text-gray-500" data-id="element-1554">|</span>
              <span data-id="element-1555">240-575-5852</span>
            </p>
          </div>
        </section>
      </main>

      <Footer data-id="element-1556" />
      <MobileStickyBar data-id="element-1557" />
    </div>;
}